// UX/UI dizayn — xizmat sahifasi kontenti (uz / ru)
// Shakl: src/content/services/_shape.js

const uz = {
    meta: {
        title: "UX/UI dizayn — sayt va mobil ilova interfeysi dizayni | Innobek",
        description:
            "UX/UI dizayn xizmati: foydalanuvchi tadqiqoti, wireframe, Figma prototip, interfeys dizayni va dizayn tizimi. Narx 9 000 000 so'mdan, muddat 2–8 hafta.",
        keywords: [
            "ux ui dizayn",
            "interfeys dizayni",
            "sayt dizayni",
            "mobil ilova dizayni",
            "figma prototip",
            "dizayn tizimi",
            "ux tadqiqot",
            "veb dizayn narxi",
        ],
    },

    hero: {
        eyebrow: "UX/UI dizayn",
        h1: "UX/UI dizayn: foydalanuvchi o'ylamasdan tushunadigan interfeys",
        lead:
            "Chiroyli ekran va ishlaydigan ekran — bu ikki xil narsa. Biz avval odam sizning saytingizda nima qilmoqchi ekanini aniqlaymiz, keyin shu yo'lni eng qisqa qilib chizamiz. Natija: Figmada bosiladigan prototip, tayyor makestlar va dasturchiga topshiriladigan dizayn tizimi.",
        ctaPrimary: "Dizayn uchun ariza qoldirish",
        ctaSecondary: "Narx va muddatni ko'rish",
        proof: [
            "200+ topshirilgan loyiha",
            "Figma, real komponentlar bilan",
            "Prototip tayyor bo'lgach kod yoziladi",
            "Mobil va desktop uchun alohida ishlanadi",
            "Manba fayllar to'liq sizga o'tadi",
        ],
    },

    intro: {
        h: "UX/UI dizayn nima va u nima uchun kerak?",
        p: [
            "Ko'p sayt va ilova texnik jihatdan to'g'ri ishlaydi, lekin odam ulardan foydalana olmaydi. Tugma qayerdaligi ko'rinmaydi, forma juda uzun, keyingi qadam tushunarsiz. Foydalanuvchi bir-ikki urinishdan keyin chiqib ketadi. Siz esa buni «reklama yomon ishladi» deb hisoblaysiz va byudjetni yana reklamaga tashlaysiz.",
            "UX/UI dizayn aynan shu yo'qotishni kamaytirish uchun kerak. UX — bu struktura: qaysi ekranlar bor, ular qanday ketma-ketlikda ochiladi, foydalanuvchi maqsadiga necha bosishda yetadi. UI — bu ko'rinish: tipografika, ranglar, bo'shliqlar, holatlar. Ikkalasi birga ishlaydi. Faqat chiroyli UI yomon strukturani qutqara olmaydi.",
            "Innobek jamoasi ishni tadqiqotdan boshlaydi. Sizning biznesingiz, mijozingiz va raqobatchilaringizni o'rganamiz, mavjud sayt statistikasini (agar bo'lsa) ko'ramiz. Shundan keyin foydalanuvchi yo'llarini chizamiz, wireframe qilamiz va faqat oxirida rang va shriftga o'tamiz. Bu tartib teskari bo'lsa, qayta ishlash ikki barobar ko'p vaqt oladi.",
            "Har bir loyiha Figmada olib boriladi. Siz jarayonni real vaqtda ko'rasiz, izoh qoldirasiz, versiyalarni solishtirasiz. Topshirishda dasturchi tayyor komponentlar, o'lchamlar va holatlar bilan ishlaydi — «bu yerda qancha bo'shliq kerak?» degan savol chiqmaydi.",
            "Bu xizmat hammaga ham kerak emas. Agar sizga bir sahifalik oddiy sayt kerak bo'lsa va byudjet cheklangan bo'lsa, tayyor shablon arzonroq chiqadi — buni ochiq aytamiz. UX/UI dizayn o'zini oqlaydigan holat: mahsulotingiz murakkab, foydalanuvchi ko'p qadam bosadi yoki hozirgi interfeys konversiyani yo'qotayotgani ko'rinib turibdi.",
            "Yana bir muhim jihat — dizayn hujjat sifatida qoladi. Loyiha tugagach sizda faqat rasmlar emas, balki komponentlar kutubxonasi, tokenlar va foydalanish qoidalari bo'ladi. Ertaga boshqa dasturchi yoki dizayner kelsa, u noldan boshlamaydi. Bu ayniqsa jamoasi o'sib borayotgan kompaniyalar uchun muhim: har bir yangi sahifa avvalgisiga o'xshab qoladi.",
        ],
    },

    definition: {
        term: "UX/UI dizayn nima?",
        text:
            "UX/UI dizayn — sayt, ilova yoki tizim interfeysini foydalanuvchi maqsadiga eng qisqa yo'l bilan yetkazadigan qilib loyihalash jarayoni. UX strukturani va foydalanuvchi yo'lini, UI esa vizual ko'rinish va komponentlarni belgilaydi.",
    },

    included: {
        eyebrow: "Nimalar kiradi",
        h: "Dizayn loyihasiga nimalar kiradi",
        sub: "Quyidagilar bazaviy ish hajmi — tarifga qarab chuqurligi o'zgaradi.",
        items: [
            "Biznes va maqsadli auditoriya bo'yicha brif",
            "Raqobatchilar interfeysini tahlil qilish (3–5 ta)",
            "Foydalanuvchi yo'llari va ekranlar xaritasi",
            "Wireframe — rangsiz struktura makestlari",
            "Figmada bosiladigan interaktiv prototip",
            "Desktop va mobil uchun alohida makestlar",
            "Tipografika, rang palitrasi va ikonka to'plami",
            "Komponentlar kutubxonasi: tugma, forma, kartochka, modal",
            "Bo'sh, yuklanish va xato holatlari dizayni",
            "Kontrast va o'qilish bo'yicha tekshiruv (WCAG AA)",
            "Dasturchiga topshirish: o'lchamlar, tokenlar, eksport",
            "Rasm va shrift og'irligi bo'yicha tavsiyalar",
            "Sahifa sarlavhalari va tugma matnlari (mikrokopi)",
            "Topshirishdan keyin 2 hafta dizayner yordami",
        ],
    },

    benefits: {
        eyebrow: "Nima beradi",
        h: "Yaxshi interfeys qanday natija beradi",
        sub: "Dizayn — bu estetika emas, bu o'lchanadigan biznes ko'rsatkichi.",
        items: [
            {
                t: "Ariza soni oshadi",
                d: "Aniq struktura va qisqartirilgan forma bilan konversiya odatda 20–40% ko'tariladi. Trafik o'zgarmaydi — shu trafikdan olinadigan natija o'zgaradi.",
            },
            {
                t: "Dasturlash arzonlashadi",
                d: "Prototip tasdiqlangandan keyin kod yoziladi. Dasturchi «tushunmadim» deb qayta yozmaydi — bu odatda loyihaning 15–25% vaqtini tejaydi.",
            },
            {
                t: "Qo'llab-quvvatlash soddalashadi",
                d: "Dizayn tizimi bor bo'lsa, yangi sahifa bir necha soatda yig'iladi. Har safar noldan chizish shart emas.",
            },
            {
                t: "Mobil foydalanuvchi yo'qolmaydi",
                d: "O'zbekistonda trafikning 70–80% telefondan keladi. Mobil makest alohida chizilsa, matn kichiklashmaydi va tugmalar barmoqqa moslashadi.",
            },
            {
                t: "Jamoada bahs kamayadi",
                d: "«Menga bu rang yoqmaydi» o'rniga «bu ekranda maqsad nima?» degan savol muhokama qilinadi. Qaror tezroq va dalilga tayanib qabul qilinadi.",
            },
            {
                t: "Brend bir xil ko'rinadi",
                d: "Sayt, ilova, prezentatsiya va reklama bannerlari bitta palitra va tipografikada bo'ladi. Bu tanilishni oshiradi.",
            },
            {
                t: "Xatolar oldindan topiladi",
                d: "Prototipni 5–7 odamga ko'rsatib, qayerda adashishini ko'ramiz. Ishga tushgandan keyin xuddi shu tuzatish 5–10 barobar qimmatga tushadi, chunki kod ham, testlar ham qayta yoziladi.",
            },
            {
                t: "Yangi xodim tez o'rganadi",
                d: "Komponentlar hujjatlashtirilgan bo'lsa, jamoaga qo'shilgan dizayner yoki dasturchi bir-ikki kunda ishga kirishadi.",
            },
            {
                t: "Sayt tezroq ochiladi",
                d: "Dizayn bosqichida rasm og'irligi va shriftlar soni nazorat qilinadi. Bu PageSpeed ballariga va Google reytingiga to'g'ridan-to'g'ri ta'sir qiladi.",
            },
        ],
    },

    audience: {
        eyebrow: "Kimlar uchun",
        h: "UX/UI dizayn kimlarga kerak",
        sub: "Quyidagi holatlarda dizaynga sarflangan pul tez qaytadi.",
        items: [
            {
                t: "Yangi mahsulot ishga tushirayotganlar",
                d: "Kod yozishdan oldin prototip qilish arzonroq. Investor yoki rahbariyatga ham tayyor ekranlarni ko'rsatish oson.",
            },
            {
                t: "Konversiyasi pasayganlar",
                d: "Trafik bor, ariza yo'q. Odatda muammo sayt strukturasida va forma uzunligida bo'ladi, reklamada emas.",
            },
            {
                t: "Eski saytni yangilayotganlar",
                d: "5–7 yillik sayt mobil qurilmalarda buziladi va zamonaviy ko'rinmaydi. Redizayn kontentni saqlagan holda qilinadi.",
            },
            {
                t: "Ichki tizim egalari",
                d: "CRM yoki admin panel xodimlar uchun. Qulay interfeys xato kiritishni kamaytiradi va o'qitish vaqtini qisqartiradi.",
            },
            {
                t: "Mobil ilova rejalashtirayotganlar",
                d: "iOS va Android o'z qoidalariga ega. Ularni hisobga olmagan ilova store moderatsiyasidan o'tmasligi mumkin.",
            },
            {
                t: "Bir nechta mahsuloti borlar",
                d: "Har biri boshqacha ko'rinadi. Dizayn tizimi hammasini bitta tilga keltiradi va kelajakdagi ishni tezlashtiradi.",
            },
            {
                t: "Investor izlayotgan startaplar",
                d: "Tayyor prototip g'oyani so'z bilan tushuntirishdan ancha kuchli ishlaydi. Uni taqdimotda ochib, bosib ko'rsatish mumkin.",
            },
            {
                t: "Dasturchisi bor, dizayneri yo'q jamoalar",
                d: "Kod yozadigan odam bor, lekin ekranlarni kim chizadi degan savol qoladi. Biz shu bo'shliqni to'ldiramiz va sizning repozitoriyingiz ostida ishlaymiz.",
            },
        ],
    },

    pricing: {
        eyebrow: "Narxlar",
        h: "UX/UI dizayn qancha turadi",
        sub: "Narx ekranlar soni va mantiq murakkabligiga bog'liq. Quyida odatiy oraliqlar.",
        note:
            "Aniq summa brifdan keyin, 1–2 kun ichida beriladi. To'lov ikki yoki uch bosqichda amalga oshiriladi: boshlanishda 50%, prototip tasdiqlangach va topshirishda qolgani. Agar sizga doimiy dizayner kerak bo'lsa, oylik format ham bor — oyiga 12 000 000 so'mdan, navbatdagi vazifalar cheksiz, bir vaqtda bitta vazifa ishlanadi va uni istalgan oyda to'xtatish mumkin. Narxga nima kirmasligini ham ochiq aytamiz: kontent yozish, professional fotosessiya, illyustratsiya chizish va dasturlash alohida hisoblanadi. Narxlarga QQS kiritilmagan.",
        tiers: [
            {
                name: "Audit va redizayn",
                tagline: "Mavjud interfeysni tuzatish",
                price: "9 000 000",
                priceNote: "so'mdan",
                term: "2–3 hafta",
                best: "Sayti bor, lekin konversiya past bo'lganlar",
                features: [
                    "Mavjud sayt yoki ilova auditi",
                    "Analitika va xatti-harakat yozuvlarini tahlil qilish",
                    "Muammolar ro'yxati va ustuvorlik jadvali",
                    "Asosiy 5–8 ekran uchun yangi makest",
                    "Mobil versiya alohida",
                    "Tavsiyalar hujjati (PDF)",
                ],
            },
            {
                name: "Mahsulot dizayni",
                tagline: "Noldan to'liq interfeys",
                price: "22 000 000",
                priceNote: "so'mdan",
                term: "4–6 hafta",
                best: "Yangi sayt, veb-ilova yoki mobil ilova",
                featured: true,
                features: [
                    "Brif, tadqiqot va raqobatchilar tahlili",
                    "Foydalanuvchi yo'llari va ekranlar xaritasi",
                    "Wireframe va interaktiv prototip",
                    "15–25 ta tayyor ekran, desktop va mobil",
                    "Komponentlar kutubxonasi Figmada",
                    "Bo'sh, yuklanish va xato holatlari",
                    "Dasturchiga topshirish va 2 hafta yordam",
                ],
            },
            {
                name: "Dizayn tizimi",
                tagline: "Katta mahsulot uchun baza",
                price: "55 000 000",
                priceNote: "so'mdan",
                term: "6–8 hafta",
                best: "Bir nechta mahsuloti yoki katta jamoasi borlar",
                features: [
                    "Dizayn tokenlari: rang, shrift, bo'shliq, radius",
                    "40+ komponent, barcha holatlari bilan",
                    "Qorong'i rejim (dark mode) variantlari",
                    "Foydalanish qoidalari va hujjat",
                    "Kod komponentlari bilan moslashtirish",
                    "Jamoangiz uchun 2 ta o'quv sessiyasi",
                    "3 oy davomida tizimni yangilab turish",
                ],
            },
        ],
    },

    process: {
        eyebrow: "Jarayon",
        h: "Dizayn qanday bosqichlarda qilinadi",
        sub: "Har bosqich oxirida siz natijani ko'rasiz va tasdiqlaysiz.",
        steps: [
            {
                t: "Brif va maqsadlar",
                time: "1–2 kun",
                d: "Biznesingiz, mijozingiz va asosiy maqsadli harakat haqida suhbatlashamiz. Muvaffaqiyat qanday o'lchanishini yozib olamiz.",
            },
            {
                t: "Tadqiqot",
                time: "3–5 kun",
                d: "Raqobatchilarni ko'ramiz, mavjud analitikani tahlil qilamiz, kerak bo'lsa 3–5 foydalanuvchi bilan suhbat o'tkazamiz.",
            },
            {
                t: "Struktura va yo'llar",
                time: "2–4 kun",
                d: "Ekranlar xaritasi va foydalanuvchi ssenariylari chiziladi. Shu bosqichda ortiqcha ekranlar olib tashlanadi.",
            },
            {
                t: "Wireframe",
                time: "4–7 kun",
                d: "Rangsiz makestlar. Diqqat faqat joylashuv va mantiqda bo'ladi — bu bosqichda o'zgartirish eng arzon.",
            },
            {
                t: "Vizual dizayn",
                time: "1–2 hafta",
                d: "Tipografika, rang, ikonka va komponentlar. Avval 2 ta asosiy ekran ko'rsatiladi, yo'nalish tasdiqlangach qolgani ishlanadi.",
            },
            {
                t: "Prototip va sinov",
                time: "3–5 kun",
                d: "Bosiladigan prototip yig'iladi. Uni bir necha odamga ko'rsatib, adashadigan joylar tuzatiladi.",
            },
            {
                t: "Topshirish",
                time: "2–3 kun",
                d: "Figma fayli, eksport qilingan rasmlar va spetsifikatsiya beriladi. Dasturchi bilan qo'ng'iroq o'tkaziladi va savollar yopiladi.",
            },
            {
                t: "Ishga tushgandan keyin",
                time: "2 hafta",
                d: "Dasturlash davomida chiqadigan savollarga javob beramiz, kerak bo'lsa yetishmayotgan holatlarni qo'shib chizamiz. Bu narxga kiradi.",
            },
        ],
    },

    samples: {
        eyebrow: "Namunalar",
        h: "Biz dizayn qilgan interfeyslar",
        sub: "Turli sohalardagi loyihalar — mobil ilova, internet-do'kon, media va korporativ sayt. Har birida struktura tadqiqotdan boshlangan, keyin vizual dizaynga o'tilgan.",
        cta: "Barcha loyihalarni ko'rish",
        slugs: ["anibla", "wogme", "myyurist", "atlet", "scriber-arts"],
    },

    faq: {
        eyebrow: "Savol-javob",
        h: "Ko'p beriladigan savollar",
        sub: "UX/UI dizayn bo'yicha eng ko'p so'raladigan savollar va qisqa javoblar.",
        items: [
            {
                q: "UX/UI dizayn qancha turadi?",
                a: "Mavjud saytni audit qilish va asosiy ekranlarni qayta chizish 9 000 000 so'mdan boshlanadi. Noldan to'liq mahsulot dizayni 22 000 000 so'mdan, dizayn tizimi esa 55 000 000 so'mdan. Aniq summa ekranlar soni, mantiq murakkabligi va mobil versiya kerakligiga bog'liq. Hisob-kitobni brifdan keyin 1–2 kun ichida beramiz.",
            },
            {
                q: "Dizayn qancha vaqt oladi?",
                a: "Audit va redizayn odatda 2–3 hafta, to'liq mahsulot dizayni 4–6 hafta, dizayn tizimi 6–8 hafta oladi. Muddat sizning javob berish tezligingizga ham bog'liq: har bosqichda tasdiq kerak. Agar izohlar bir haftada kelsa, umumiy muddat shuncha uzayadi. Shuning uchun boshida sizning tomondan qaror qabul qiladigan bitta mas'ul odamni belgilashni so'raymiz — bu muddatni sezilarli qisqartiradi.",
            },
            {
                q: "UX va UI orasidagi farq nima?",
                a: "UX — bu mantiq va struktura: qaysi ekranlar bor, foydalanuvchi maqsadiga qanday yetadi, qaysi qadam ortiqcha. UI — bu ko'rinish: shrift, rang, bo'shliq, ikonka, animatsiya. UX yomon bo'lsa, chiroyli UI yordam bermaydi — odam nima qilishni tushunmaydi va chiqib ketadi.",
            },
            {
                q: "Faqat dizayn qilasizmi yoki saytni ham yaratasizmi?",
                a: "Ikkalasini ham qilamiz. Ko'p mijoz dizayn va dasturlashni bitta jamoaga beradi — bu tezroq va javobgarlik bir joyda bo'ladi. Lekin siz faqat dizaynni buyurtma qilib, kodni o'z dasturchingizga topshirishingiz mumkin. Bunday holda topshirishda batafsil spetsifikatsiya, eksport qilingan grafika va 2 hafta konsultatsiya beriladi. Dasturchingiz bilan alohida qo'ng'iroq ham o'tkazamiz.",
            },
            {
                q: "Nechta tuzatish kiritsam bo'ladi?",
                a: "Har bosqichda ikki tur tuzatish narxga kiradi: wireframe bo'yicha ikki, vizual dizayn bo'yicha ikki marta. Amalda bu yetarli bo'ladi, chunki har bosqich alohida tasdiqlanib o'tiladi. Allaqachon tasdiqlangan bosqichga qaytish kerak bo'lsa, qo'shimcha vaqt alohida hisoblanadi va siz bilan oldindan kelishiladi — kutilmagan hisob chiqmaydi.",
            },
            {
                q: "Figma fayli menga tegishli bo'ladimi?",
                a: "Ha. Topshirishda Figma loyihasi to'liq sizga o'tkaziladi: barcha ekranlar, komponentlar, tokenlar va versiyalar tarixi. Uni boshqa dizaynerga berishingiz yoki o'zingiz tahrirlashingiz mumkin. Bizda hech qanday cheklov, obuna yoki «kalitni ushlab turish» amaliyoti yo'q. Manba fayllar shartnomaga ko'ra sizning mulkingiz hisoblanadi.",
            },
            {
                q: "Tayyor shablon olganim arzonroq emasmi?",
                a: "Arzonroq, va ba'zi hollarda bu to'g'ri qaror. Oddiy vizitka sayt kerak bo'lsa, shablon bir necha kunda ishga tushadi. Lekin shablon sizning jarayoningizni bilmaydi: murakkab forma, kalkulyator yoki ko'p bosqichli buyurtma kerak bo'lsa, uni moslashtirish noldan chizishdan qimmatroq tushadi. Biz konsultatsiyada qaysi yo'l arzonroq ekanini ochiq aytamiz.",
            },
            {
                q: "Dizayn konversiyani oshirishiga kafolat beramisiz?",
                a: "Aniq foizni kafolatlamaymiz — natijaga narx, taklif va trafik sifati ham ta'sir qiladi. Lekin biz o'lchash tizimini o'rnatamiz: maqsadli harakatlar sanaladi, eski va yangi versiya ko'rsatkichlarini solishtirasiz. Tajribamizda struktura va formani soddalashtirish odatda 20–40% o'sish beradi. Raqam ko'rinmasa, sababini birga qidiramiz.",
            },
            {
                q: "Mobil versiya alohida to'lanadimi?",
                a: "Yo'q, mobil makestlar barcha tarifga kiradi. Biz avval mobil versiyani chizamiz, keyin desktopga kengaytiramiz, chunki O'zbekistonda trafikning 70–80% telefondan keladi. Planshet versiyasi esa alohida kelishiladi — u ko'pincha kerak bo'lmaydi va desktop makestidan avtomatik kelib chiqadi. Sekin internetda sahifa qanday ochilishini ham hisobga olamiz.",
            },
            {
                q: "Ishni boshlash uchun mendan nima kerak?",
                a: "Kamida uchta narsa: biznesingiz haqida qisqacha ma'lumot, qaror qabul qiladigan mas'ul odam va yoqqan yoki yoqmagan 3–5 ta sayt havolasi. Logotip, brendbuk va mahsulot ro'yxati bo'lsa, ular ham foydali. Qolganini brif suhbatida birga to'ldiramiz — tayyorgarlik odatda bir kun oladi.",
            },
            {
                q: "Dizaynni o'z brend ranglarimda qilasizmi?",
                a: "Ha, brendbukingiz bo'lsa uni asos qilamiz. Agar ranglar ekranda yomon o'qilsa yoki kontrast yetmasa, buni aytamiz va muqobil variant taklif qilamiz — bosma va ekran uchun palitra har doim ham bir xil ishlamaydi. Brendbuk yo'q bo'lsa, palitra va tipografikani noldan tuzamiz.",
            },
        ],
    },

    cta: {
        h: "Interfeysingizni ko'rib chiqaylikmi?",
        p: "Bepul konsultatsiyada saytingiz yoki ilovangizni ochib, qayerda foydalanuvchi yo'qotilayotganini aytamiz. Suhbat 30 daqiqa, majburiyat yo'q. Qo'ng'iroq: +998 90 954 12 62.",
        button: "Bepul konsultatsiya olish",
        secondary: "Telegram orqali yozish",
    },

    images: [
        {
            src: "/assets/img/services/ux-ui-dizayn-hero.webp",
            alt: "UX/UI dizayner Figmada mobil ilova interfeysi makestini chizmoqda",
            caption: "Har bir loyiha Figmada olib boriladi — siz jarayonni real vaqtda ko'rasiz.",
            prompt:
                "Wide hero image, modern design studio desk seen slightly from above. A large monitor shows a Figma canvas with mobile app screens, component library panel on the left, layers panel on the right. Neutral dark UI, soft blue and violet accent colors. Warm daylight from a window, shallow depth of field, no visible faces, no readable brand logos. Photographic, 16:9, clean and professional.",
        },
        {
            src: "/assets/img/services/ux-ui-dizayn-wireframe.webp",
            alt: "Wireframe va tayyor UI makest yonma-yon: sayt strukturasidan vizual dizaynga",
            caption: "Avval rangsiz struktura, keyin vizual dizayn. Bu tartib qayta ishlashni kamaytiradi.",
            prompt:
                "Split comparison image: left half shows grey low-fidelity wireframe of a web page (boxes, placeholder lines, no color), right half shows the same layout as a finished high-fidelity UI with typography, color and imagery. Flat vector illustration style, light background, thin outlines, subtle shadow. 16:9.",
        },
        {
            src: "/assets/img/services/ux-ui-dizayn-system.webp",
            alt: "Dizayn tizimi komponentlari: tugmalar, formalar, kartochkalar va rang tokenlari",
            caption: "Dizayn tizimi — yangi sahifani soatlar ichida yig'ish imkonini beradi.",
            prompt:
                "Organized grid of UI components on a neutral canvas: buttons in several states, input fields, toggles, cards, modals, color token swatches and a type scale. Clean flat style, generous spacing, light and dark variants side by side, subtle grid guides. Looks like a design system documentation page. 16:9.",
        },
        {
            src: "/assets/img/services/ux-ui-dizayn-mobile.webp",
            alt: "Bitta interfeysning telefon, planshet va noutbukdagi moslashuvchan ko'rinishi",
            caption: "Mobil makest birinchi chiziladi — trafikning katta qismi telefondan keladi.",
            prompt:
                "Three devices — smartphone, tablet and laptop — arranged on a light surface, each showing the same web interface adapted to its screen size. Minimal abstract UI on screens, no real brand names. Soft studio lighting, muted background, slight angle, product-photography look. 16:9.",
        },
    ],

    related: ["veb-ilovalar", "mobil-ilova", "korporativ-saytlar", "landing-page"],
};

const ru = {
    meta: {
        title: "UX/UI дизайн — дизайн интерфейса сайта и мобильного приложения | Innobek",
        description:
            "UX/UI дизайн: исследование пользователей, wireframe, кликабельный прототип в Figma, интерфейс и дизайн-система. Цена от 9 000 000 сум, срок 2–8 недель.",
        keywords: [
            "ux ui дизайн",
            "дизайн интерфейса",
            "дизайн сайта",
            "дизайн мобильного приложения",
            "прототип figma",
            "дизайн-система",
            "ux исследование",
            "стоимость веб-дизайна",
        ],
    },

    hero: {
        eyebrow: "UX/UI дизайн",
        h1: "UX/UI дизайн: интерфейс, который понятен без объяснений",
        lead:
            "Красивый экран и работающий экран — разные вещи. Мы сначала выясняем, зачем человек пришёл на ваш сайт, и только потом делаем этот путь максимально коротким. На выходе: кликабельный прототип в Figma, готовые макеты и библиотека компонентов для разработчика.",
        ctaPrimary: "Оставить заявку на дизайн",
        ctaSecondary: "Посмотреть цены и сроки",
        proof: [
            "200+ сданных проектов",
            "Работаем в Figma с реальными компонентами",
            "Код пишется после утверждения прототипа",
            "Мобильная и десктопная версии отдельно",
            "Исходные файлы полностью переходят к вам",
        ],
    },

    intro: {
        h: "Что такое UX/UI дизайн и зачем он нужен",
        p: [
            "Многие сайты и приложения технически исправны, но пользоваться ими тяжело. Кнопку не видно, форма слишком длинная, следующий шаг неочевиден. Человек уходит после второй попытки. А вы списываете это на «плохую рекламу» и снова увеличиваете бюджет на трафик.",
            "UX/UI дизайн устраняет именно эту потерю. UX — это структура: какие экраны есть, в каком порядке они открываются, за сколько кликов человек достигает цели. UI — это оформление: типографика, цвет, отступы, состояния элементов. Они работают только вместе. Красивый UI не спасёт плохую структуру.",
            "Команда Innobek начинает с исследования. Изучаем ваш бизнес, аудиторию и конкурентов, смотрим статистику текущего сайта, если она есть. Затем рисуем пользовательские сценарии и wireframe, и только в конце переходим к цвету и шрифтам. Если делать наоборот, переделок будет вдвое больше.",
            "Весь проект ведётся в Figma. Вы видите работу в реальном времени, оставляете комментарии прямо на макете, сравниваете версии. При передаче разработчик получает компоненты, размеры и все состояния — вопрос «а какой здесь отступ?» просто не возникает.",
            "Эта услуга нужна не всем. Если вам нужен простой одностраничный сайт и бюджет ограничен, готовый шаблон обойдётся дешевле — мы говорим об этом честно. UX/UI дизайн окупается, когда продукт сложный, пользователь проходит много шагов или текущий интерфейс явно теряет заявки.",
            "Ещё один важный момент: дизайн остаётся у вас как документация. После проекта вы получаете не набор картинок, а библиотеку компонентов, токены и правила использования. Если позже придёт другой разработчик или дизайнер, он не начнёт с нуля. Это особенно ценно для растущих команд: каждая новая страница получается похожей на предыдущие.",
        ],
    },

    definition: {
        term: "Что такое UX/UI дизайн?",
        text:
            "UX/UI дизайн — это проектирование интерфейса сайта, приложения или системы так, чтобы пользователь достигал своей цели кратчайшим путём. UX отвечает за структуру и сценарии, UI — за визуальное оформление и компоненты.",
    },

    included: {
        eyebrow: "Что входит",
        h: "Что входит в проект по дизайну",
        sub: "Это базовый объём работ — глубина проработки зависит от тарифа.",
        items: [
            "Бриф по бизнесу и целевой аудитории",
            "Разбор интерфейсов конкурентов (3–5 сайтов)",
            "Карта экранов и пользовательские сценарии",
            "Wireframe — структурные макеты без цвета",
            "Кликабельный интерактивный прототип в Figma",
            "Отдельные макеты для десктопа и мобильных устройств",
            "Типографика, цветовая палитра и набор иконок",
            "Библиотека компонентов: кнопки, формы, карточки, модальные окна",
            "Дизайн пустых состояний, загрузки и ошибок",
            "Проверка контраста и читаемости (WCAG AA)",
            "Передача разработчику: размеры, токены, экспорт",
            "Две недели поддержки дизайнера после сдачи",
        ],
    },

    benefits: {
        eyebrow: "Что это даёт",
        h: "Какой результат даёт продуманный интерфейс",
        sub: "Дизайн — не эстетика, а измеримый бизнес-показатель.",
        items: [
            {
                t: "Больше заявок",
                d: "Понятная структура и короткая форма обычно поднимают конверсию на 20–40%. Трафик тот же — меняется результат, который вы из него получаете.",
            },
            {
                t: "Разработка дешевле",
                d: "Код пишется по утверждённому прототипу. Разработчику не приходится переделывать из-за недопонимания — это экономит 15–25% времени проекта.",
            },
            {
                t: "Поддержка проще",
                d: "С дизайн-системой новая страница собирается за несколько часов из готовых блоков, а не рисуется с нуля каждый раз.",
            },
            {
                t: "Мобильный пользователь не теряется",
                d: "В Узбекистане 70–80% трафика идёт с телефонов. Отдельный мобильный макет означает нормальный размер текста и кнопки под палец.",
            },
            {
                t: "Меньше споров в команде",
                d: "Вместо «мне не нравится этот цвет» обсуждается «какая цель у этого экрана». Решения принимаются быстрее и аргументированнее.",
            },
            {
                t: "Бренд выглядит цельно",
                d: "Сайт, приложение, презентации и рекламные баннеры используют одну палитру и типографику. Это повышает узнаваемость.",
            },
            {
                t: "Ошибки находятся заранее",
                d: "Прототип показываем 5–7 пользователям и смотрим, где они сбиваются. Исправление после запуска стоит в 5–10 раз дороже.",
            },
            {
                t: "Новый сотрудник быстро включается",
                d: "Когда компоненты задокументированы, пришедший дизайнер или разработчик входит в работу за пару дней.",
            },
            {
                t: "Страницы грузятся быстрее",
                d: "Уже на этапе дизайна контролируем вес изображений и количество шрифтов. Это напрямую влияет на баллы PageSpeed и позиции в Google.",
            },
        ],
    },

    audience: {
        eyebrow: "Кому подходит",
        h: "Кому нужен UX/UI дизайн",
        sub: "В этих случаях вложение в дизайн возвращается быстрее всего.",
        items: [
            {
                t: "Запускают новый продукт",
                d: "Прототип дешевле кода. И инвестору или руководству проще показать готовые экраны, чем объяснять словами.",
            },
            {
                t: "Упала конверсия",
                d: "Трафик есть, заявок нет. Чаще всего дело в структуре сайта и длине формы, а не в рекламе.",
            },
            {
                t: "Обновляют старый сайт",
                d: "Сайту 5–7 лет, он ломается на телефонах и выглядит устаревшим. Редизайн делается с сохранением контента и позиций.",
            },
            {
                t: "Владельцы внутренних систем",
                d: "CRM или админ-панель для сотрудников. Удобный интерфейс снижает число ошибок ввода и время на обучение.",
            },
            {
                t: "Планируют мобильное приложение",
                d: "У iOS и Android свои гайдлайны. Приложение, которое их игнорирует, рискует не пройти модерацию в App Store и Google Play.",
            },
            {
                t: "Компании с несколькими продуктами",
                d: "Каждый выглядит по-своему. Дизайн-система приводит всё к одному языку и ускоряет будущую работу.",
            },
            {
                t: "Стартапы в поиске инвестора",
                d: "Готовый прототип убеждает сильнее, чем описание словами: его можно открыть прямо на встрече и покликать.",
            },
            {
                t: "Команды с разработчиком, но без дизайнера",
                d: "Код писать есть кому, а экраны рисовать некому. Мы закрываем этот пробел и работаем внутри вашего процесса и репозитория.",
            },
        ],
    },

    pricing: {
        eyebrow: "Цены",
        h: "Сколько стоит UX/UI дизайн",
        sub: "Цена зависит от количества экранов и сложности логики. Ниже типичные диапазоны.",
        note:
            "Точную сумму называем в течение 1–2 дней после брифа. Оплата в два или три этапа: 50% на старте, остальное после утверждения прототипа и при сдаче. Если нужен постоянный дизайнер, есть месячный формат — от 12 000 000 сум в месяц, очередь задач не ограничена, в работе одновременно одна задача, остановить сотрудничество можно в любом месяце. Честно говорим и о том, что не входит: написание текстов, профессиональная фотосъёмка, авторские иллюстрации и разработка считаются отдельно. Цены указаны без НДС.",
        tiers: [
            {
                name: "Аудит и редизайн",
                tagline: "Починить существующий интерфейс",
                price: "9 000 000",
                priceNote: "сум, от",
                term: "2–3 недели",
                best: "Тем, у кого сайт есть, но конверсия низкая",
                features: [
                    "Аудит текущего сайта или приложения",
                    "Разбор аналитики и записей поведения",
                    "Список проблем с приоритетами",
                    "Новые макеты для 5–8 ключевых экранов",
                    "Отдельная мобильная версия",
                    "Документ с рекомендациями (PDF)",
                ],
            },
            {
                name: "Дизайн продукта",
                tagline: "Полный интерфейс с нуля",
                price: "22 000 000",
                priceNote: "сум, от",
                term: "4–6 недель",
                best: "Новый сайт, веб-сервис или мобильное приложение",
                featured: true,
                features: [
                    "Бриф, исследование и разбор конкурентов",
                    "Карта экранов и пользовательские сценарии",
                    "Wireframe и кликабельный прототип",
                    "15–25 готовых экранов, десктоп и мобильные",
                    "Библиотека компонентов в Figma",
                    "Пустые состояния, загрузка и ошибки",
                    "Передача разработчику и 2 недели поддержки",
                ],
            },
            {
                name: "Дизайн-система",
                tagline: "База для большого продукта",
                price: "55 000 000",
                priceNote: "сум, от",
                term: "6–8 недель",
                best: "Компаниям с несколькими продуктами или большой командой",
                features: [
                    "Дизайн-токены: цвет, шрифт, отступы, радиусы",
                    "40+ компонентов со всеми состояниями",
                    "Варианты для тёмной темы",
                    "Правила использования и документация",
                    "Сверка с компонентами в коде",
                    "Два обучающих занятия для вашей команды",
                    "Обновление системы в течение 3 месяцев",
                ],
            },
        ],
    },

    process: {
        eyebrow: "Процесс",
        h: "Как устроена работа над дизайном",
        sub: "После каждого этапа вы видите результат и утверждаете его.",
        steps: [
            {
                t: "Бриф и цели",
                time: "1–2 дня",
                d: "Обсуждаем бизнес, аудиторию и главное целевое действие. Фиксируем, чем будем измерять успех.",
            },
            {
                t: "Исследование",
                time: "3–5 дней",
                d: "Смотрим конкурентов, разбираем текущую аналитику, при необходимости говорим с 3–5 реальными пользователями.",
            },
            {
                t: "Структура и сценарии",
                time: "2–4 дня",
                d: "Рисуем карту экранов и пути пользователя. На этом шаге лишние экраны убираются, пока они ничего не стоят.",
            },
            {
                t: "Wireframe",
                time: "4–7 дней",
                d: "Макеты без цвета. Внимание только к компоновке и логике — здесь правки обходятся дешевле всего.",
            },
            {
                t: "Визуальный дизайн",
                time: "1–2 недели",
                d: "Типографика, цвет, иконки, компоненты. Сначала показываем 2 ключевых экрана, после утверждения стиля делаем остальные.",
            },
            {
                t: "Прототип и проверка",
                time: "3–5 дней",
                d: "Собираем кликабельный прототип, показываем нескольким людям и правим места, где они сбиваются.",
            },
            {
                t: "Передача",
                time: "2–3 дня",
                d: "Отдаём файл Figma, экспортированную графику и спецификацию. Проводим созвон с вашим разработчиком и закрываем вопросы.",
            },
            {
                t: "Сопровождение после сдачи",
                time: "2 недели",
                d: "Отвечаем на вопросы по ходу разработки и дорисовываем недостающие состояния, если они всплывают. Это входит в стоимость.",
            },
        ],
    },

    samples: {
        eyebrow: "Примеры",
        h: "Интерфейсы, которые мы спроектировали",
        sub: "Проекты из разных сфер — мобильное приложение, интернет-магазин и корпоративный сайт.",
        cta: "Смотреть все проекты",
        slugs: ["anibla", "wogme", "myyurist", "atlet", "scriber-arts"],
    },

    faq: {
        eyebrow: "Вопросы и ответы",
        h: "Частые вопросы",
        sub: "Коротко отвечаем на то, о чём спрашивают чаще всего.",
        items: [
            {
                q: "Сколько стоит UX/UI дизайн?",
                a: "Аудит существующего сайта с перерисовкой ключевых экранов — от 9 000 000 сум. Полный дизайн продукта с нуля — от 22 000 000 сум, дизайн-система — от 55 000 000 сум. Итоговая сумма зависит от числа экранов, сложности логики и необходимости мобильной версии. Расчёт даём в течение 1–2 дней после брифа.",
            },
            {
                q: "Сколько времени занимает дизайн?",
                a: "Аудит и редизайн обычно занимают 2–3 недели, полный дизайн продукта — 4–6 недель, дизайн-система — 6–8 недель. Срок зависит и от скорости ваших ответов: каждый этап требует утверждения. Если правки приходят через неделю, общий срок растягивается ровно на это время. Поэтому на старте просим назначить одного человека, который принимает решения с вашей стороны.",
            },
            {
                q: "Чем UX отличается от UI?",
                a: "UX — это логика и структура: какие экраны нужны, как человек доходит до цели, какой шаг лишний. UI — оформление: шрифты, цвет, отступы, иконки, анимация. Если UX слабый, красивый UI не поможет: пользователь просто не поймёт, что делать дальше, и уйдёт.",
            },
            {
                q: "Вы только рисуете или ещё и разрабатываете?",
                a: "Делаем и то, и другое. Большинство клиентов отдают дизайн и разработку одной команде — так быстрее и ответственность в одном месте. Но вы можете заказать только дизайн и передать разработку своему программисту. В этом случае при сдаче мы даём спецификацию и 2 недели консультаций.",
            },
            {
                q: "Сколько правок входит в стоимость?",
                a: "Два круга правок на каждом этапе: два по wireframe и два по визуальному дизайну. На практике этого хватает, потому что каждый этап утверждается отдельно. Если нужно вернуться к уже утверждённому этапу, дополнительное время считается отдельно и согласуется заранее — неожиданных счетов в конце проекта не появляется.",
            },
            {
                q: "Файл Figma останется у меня?",
                a: "Да. При сдаче проект Figma передаётся вам полностью: все экраны, компоненты, токены и история версий. Вы можете передать его другому дизайнеру или редактировать сами. Никаких подписок, ограничений или практики «держать ключи у себя» с нашей стороны нет. Исходники по договору принадлежат вам.",
            },
            {
                q: "Не дешевле ли взять готовый шаблон?",
                a: "Дешевле, и иногда это верное решение. Для простого сайта-визитки шаблон запускается за несколько дней. Но шаблон не знает ваших процессов: если нужны сложная форма, калькулятор или многошаговый заказ, доработка шаблона выходит дороже, чем дизайн с нуля. На консультации честно скажем, какой путь дешевле именно вам.",
            },
            {
                q: "Гарантируете рост конверсии?",
                a: "Конкретный процент не гарантируем — на результат влияют цена, предложение и качество трафика. Но мы настраиваем измерение: целевые действия считаются, и вы сравниваете показатели старой и новой версии. По нашему опыту упрощение структуры и форм обычно даёт рост в диапазоне 20–40%. Если цифры не растут, ищем причину вместе.",
            },
            {
                q: "Мобильная версия оплачивается отдельно?",
                a: "Нет, мобильные макеты входят во все тарифы. Сначала мы рисуем мобильную версию, а затем расширяем её до десктопа, потому что 70–80% трафика в Узбекистане приходит с телефонов. Планшетная версия обсуждается отдельно — она нужна далеко не всегда и обычно выводится из десктопного макета.",
            },
            {
                q: "Что нужно от меня, чтобы начать?",
                a: "Как минимум три вещи: краткое описание бизнеса, ответственный человек с правом принимать решения и 3–5 ссылок на сайты, которые вам нравятся или не нравятся. Логотип, брендбук и список продуктов тоже пригодятся. Остальное соберём вместе на брифе — подготовка обычно занимает один день.",
            },
            {
                q: "Сделаете дизайн в цветах нашего бренда?",
                a: "Да, если есть брендбук, берём его за основу. Если фирменные цвета плохо читаются на экране или не дают нужного контраста, мы об этом скажем и предложим экранный вариант палитры — печатные и цифровые цвета работают по-разному. Если брендбука нет, соберём палитру и типографику с нуля.",
            },
        ],
    },

    cta: {
        h: "Посмотрим на ваш интерфейс вместе?",
        p: "На бесплатной консультации откроем ваш сайт или приложение и покажем, где теряются пользователи. Разговор занимает 30 минут, без обязательств. Звоните: +998 90 954 12 62.",
        button: "Получить бесплатную консультацию",
        secondary: "Написать в Telegram",
    },

    images: [
        {
            src: "/assets/img/services/ux-ui-dizayn-hero.webp",
            alt: "UX/UI дизайнер рисует макет интерфейса мобильного приложения в Figma",
            caption: "Каждый проект ведётся в Figma — вы видите работу в реальном времени.",
            prompt:
                "Wide hero image, modern design studio desk seen slightly from above. A large monitor shows a Figma canvas with mobile app screens, component library panel on the left, layers panel on the right. Neutral dark UI, soft blue and violet accent colors. Warm daylight from a window, shallow depth of field, no visible faces, no readable brand logos. Photographic, 16:9, clean and professional.",
        },
        {
            src: "/assets/img/services/ux-ui-dizayn-wireframe.webp",
            alt: "Wireframe и готовый UI макет рядом: от структуры сайта к визуальному дизайну",
            caption: "Сначала структура без цвета, затем визуал. Такой порядок сокращает переделки.",
            prompt:
                "Split comparison image: left half shows grey low-fidelity wireframe of a web page (boxes, placeholder lines, no color), right half shows the same layout as a finished high-fidelity UI with typography, color and imagery. Flat vector illustration style, light background, thin outlines, subtle shadow. 16:9.",
        },
        {
            src: "/assets/img/services/ux-ui-dizayn-system.webp",
            alt: "Компоненты дизайн-системы: кнопки, формы, карточки и цветовые токены",
            caption: "Дизайн-система позволяет собирать новую страницу за считаные часы.",
            prompt:
                "Organized grid of UI components on a neutral canvas: buttons in several states, input fields, toggles, cards, modals, color token swatches and a type scale. Clean flat style, generous spacing, light and dark variants side by side, subtle grid guides. Looks like a design system documentation page. 16:9.",
        },
        {
            src: "/assets/img/services/ux-ui-dizayn-mobile.webp",
            alt: "Адаптивный вид одного интерфейса на телефоне, планшете и ноутбуке",
            caption: "Мобильный макет рисуется первым — большая часть трафика идёт с телефонов.",
            prompt:
                "Three devices — smartphone, tablet and laptop — arranged on a light surface, each showing the same web interface adapted to its screen size. Minimal abstract UI on screens, no real brand names. Soft studio lighting, muted background, slight angle, product-photography look. 16:9.",
        },
    ],

    related: ["veb-ilovalar", "mobil-ilova", "korporativ-saytlar", "landing-page"],
};

const content = { uz, ru };

export default content;
